import { createSlice } from "../helper";
import * as ObjectExtensions from "../../utils/CoreExtensions/ObjectExtensions";
import * as ArrayExtensions from "../../utils/CoreExtensions/ArrayExtensions";

// Structure = {
//   data: {
//     meetingOccurrenceId: ,
//     tasksEnabledAtTemplate: ,
//     goalsEnabledAtTemplate: ,
//     meetingConversationGuideUrl: ,
//     groupId: ,
//     isMobileOrTablet: ,
//     currentConnectionMembershipRoleName: ,
//     customTerms:
//   },
//   goalsAndTasksData: {
//     showReviewTasksFromLastMeetingWidget,
//     lastMeetingYetToHappen,
//     lastMeetingTaskIds,
//     currentMeetingTaskIds: ,
//     taskIdToDetailsMap: ,
//     tasksMetaData: ,
//     visitConnectionUrl: ,
//     visitConnectionAreaTasksWidgetUrl: ,
//     createGoalsUrl: ,
//     orgIndustryForNewGoalExamples: ,
//     goalsCount: ,
//   },
//   pastMeetingNotesData: {
//     showViewNotes,
//     openNotesInOffCanvas,
//     pastMeetingsTabUrl,
//     showViewAllPastMeetingsUrl,
//     pastMeetingOccurrenceId,
//     pastMeetingData;
//   },
//   agendaDropdownActionsData: {
//     canAttachGuide,
//     canClearGuide,
//   }
// }

const meetingAgendaTabSlice = createSlice({
  name: 'meetingAgendaTab',
  initialState: {
    data: {},
    goalsAndTasksData: {},
    pastMeetingNotesData: {},
    agendaDropdownActionsData: {},
    recommendedActions: []
  },
  reducers: {
    setData: (state, action) => {
      state.data = action.payload;
    },
    setGoalsAndTasksData: (state, action) => {
      state.goalsAndTasksData = action.payload;
    },
    setPastMeetingNotesData: (state, action) => {
      state.pastMeetingNotesData = action.payload;
    },
    setAgendaDropdownActionsData: (state, action) => {
      state.agendaDropdownActionsData = action.payload; 
    },
    updateCanClearGuide: (state, action) => {
      state.agendaDropdownActionsData.canClearGuide = action.payload.canClearGuide;
    },
    updateGoalsAndTasksData: (state, action) => {
      state.goalsAndTasksData = ObjectExtensions.deepMerge(state.goalsAndTasksData, action.payload);
    },
    updateTaskDetails: (state, action) => {
      state.goalsAndTasksData.taskIdToDetailsMap[action.payload.taskId] = ObjectExtensions.deepMerge(state.goalsAndTasksData.taskIdToDetailsMap[action.payload.taskId], action.payload.updatedTaskData);
    },
    setTasksMetaData: (state, action) => {
      state.goalsAndTasksData.tasksMetaData = action.payload;
    },
    deleteTask: (state, action) => {
      state.goalsAndTasksData.taskIdToDetailsMap = ObjectExtensions.filter({...state.goalsAndTasksData.taskIdToDetailsMap}, ([key, _value])=> key !== action.payload.taskId);
      state.goalsAndTasksData.currentMeetingTaskIds = ArrayExtensions.remove(state.goalsAndTasksData.currentMeetingTaskIds, action.payload.taskId);
      state.goalsAndTasksData.lastMeetingTaskIds = ArrayExtensions.remove(state.goalsAndTasksData.lastMeetingTaskIds, action.payload.taskId);
    },
    addNewTask: (state, action) => {
      state.goalsAndTasksData.taskIdToDetailsMap = ObjectExtensions.deepMerge(state.goalsAndTasksData.taskIdToDetailsMap, action.payload.newTask);
      if (!state.goalsAndTasksData.currentMeetingTaskIds.includes(action.payload.taskId)) {
        state.goalsAndTasksData.currentMeetingTaskIds.push(action.payload.taskId);
      }
    },
    lockTask: (state, action) => {
      let lockDetails = {};
      if (action.payload.fieldName === "task_title") {
        lockDetails.titleLockDetails = action.payload.lockDetails;
      } else if (action.payload.fieldName === "task_description") {
        lockDetails.descriptionLockDetails = action.payload.lockDetails;
      }
      const updatedData = { taskId: action.payload.fieldId, ...lockDetails };
      state.goalsAndTasksData.taskIdToDetailsMap[action.payload.fieldId] = ObjectExtensions.deepMerge(state.goalsAndTasksData.taskIdToDetailsMap[action.payload.fieldId], updatedData);
    },
    setTaskDefaultMilestoneId: (state, action) => {
      state.goalsAndTasksData.tasksMetaData.newTaskData.milestoneOptions[0][0] = action.payload.defaultMilestoneId;
      state.goalsAndTasksData.tasksMetaData.newTaskData.defaultSelectedMilestone.id = action.payload.defaultMilestoneId;
    },
    setTipsData: (state, action) => {
      state.tipsData = action.payload;
    },
    setRecommendedActions: (state, action) => {
      state.recommendedActions = action.payload;
    },
    setScheduleNextMeetingRecommendationNoteData: (state, action) => {
      state.scheduleNextMeetingRecommendationNoteData = action.payload;
    },
    removeRecommendedAction: (state, action) => {
      state.recommendedActions = state.recommendedActions.filter(
        a => a.type !== action.payload
      );
    }
  }
});

export const meetingAgendaTabActions = meetingAgendaTabSlice.actions;

export default meetingAgendaTabSlice;